import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {STATUS_MAP} from "../../../../utils/constants";
import {findCategoryByLabel} from "../../../../utils/category";

interface CategoryBannerProps {
  categoryLabel: string;
  status: string;
}

export const CategoryBanner = ({
  categoryLabel,
  status
}: CategoryBannerProps) => {
  const category = findCategoryByLabel(categoryLabel)

  return (
    <div className={`
      flex items-center justify-between px-4 py-3 text-white rounded-lg
      ${category.badgeColor}
    `}>
      <div className="flex items-center gap-2 text-lg font-semibold">
        {category.icon && (
          <FontAwesomeIcon
            icon={category.icon}
            className="text-xl"
          />
        )}
        {category.label}
      </div>
      <p className={`
        text-xs font-bold px-3 py-1 rounded-full
        ${STATUS_MAP[status].color}
      `}>
        {STATUS_MAP[status].label || "未知狀態"}
      </p>
    </div>
  )
}
